import { StackView, Input, Spinner, WrapView, Badge, Button, Text, Combobox, Icon, Menu } from '@planningcenter/tapestry-react';
import React, { useState, useRef, useEffect } from 'react';
import { ErrorCard } from '../ui/error_card.js';
import { SUBHEADING_STYLES } from '../ui/subheading.js';
import 'stream-chat-react';
import '@planningcenter/datetime-fmt';
import '../../../_virtual/moment.js';
import '../../chat_context.js';
import '../../chat_api_context.js';
import '@planningcenter/url';
import '@planningcenter/jolt-client';
import 'stream-chat';
import { useTeamOptions } from './hooks/use_team_options.js';
import { groupTeamOptions } from './utils/index.js';

const SELECT_ALL_LIMIT = 10;
const getGroupDisplayName = (groupName) => groupName
    .split("_")
    .map((word, i) => {
    if (word.toLowerCase() === "i")
        return "I";
    return i === 0
        ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        : word.toLowerCase();
})
    .join(" ");
const Teams = ({ values, onChange, isActive }) => {
    const [searchTerm, setSearchTerm] = useState("");
    const [selected, unselected, isLoading, isError] = useTeamOptions(values, isActive);
    const ref = useRef();
    if (isError)
        return (React.createElement(ErrorCard, { message: "There was an issue loading teams, please refresh and try again." }));
    let index = 0;
    const isSelectAll = { teams_i_lead: true };
    const unselectedGroups = groupTeamOptions(unselected, searchTerm);
    // temp cleanup since switch view seems to be rendering everything not just what is visible
    useEffect(() => {
        if (!isActive) {
            setSearchTerm("");
        }
    }, [isActive]);
    const groups = Object.entries(unselectedGroups);
    return (React.createElement(StackView, { spacing: 1 },
        React.createElement(StackView, { axis: "horizontal", alignItems: "center", spacing: 1 },
            React.createElement(Input.InputLabel, { controls: "teams", ...SUBHEADING_STYLES }, "Teams"),
            isLoading && React.createElement(Spinner, { size: "xs" })),
        React.createElement(StackView, { spacing: 1 },
            selected.length > 0 && (React.createElement(WrapView, { spacing: 1 }, selected.map((option) => (React.createElement(Badge, { key: option.value.team_id, renderRight: React.createElement(Button, { title: "remove", icon: { name: "general.x", size: "xs" }, theme: "naked", onClick: () => onChange({
                        appName: "Services",
                        values: (prev) => ({
                            ...prev,
                            teams: prev.teams.filter(({ team_id }) => team_id !== option.value.team_id),
                        }),
                    }) }), shrink: 1, size: "sm" },
                React.createElement(Text, { truncate: true }, option.name)))))),
            React.createElement(Combobox.Popover, { ref: ref, id: "teams", openOnFocus: true, closeOnSelect: true, onClear: () => setSearchTerm(""), onChange: (e) => setSearchTerm(e.target.value), onSelect: ({ value }) => onChange({
                    appName: "Services",
                    values: (prev) => ({
                        ...prev,
                        teams: [...prev.teams, value],
                    }),
                }), placeholder: "Search teams", renderLeft: React.createElement(Icon, { name: "general.search" }), value: searchTerm }, groups.length ? (groups.map(([groupName, groupOptions], idx) => {
                const groupDisplayName = getGroupDisplayName(groupName);
                const items = groupOptions.map((option) => (React.createElement(Combobox.Item, { key: index, index: index++, value: option },
                    React.createElement(Text, { truncate: true }, option.name))));
                const tooManyOptionsForSelectAll = groupOptions.length > SELECT_ALL_LIMIT;
                return Object.keys(unselectedGroups).length > 1 ? (React.createElement(StackView, { key: groupName, marginTop: idx > 0 ? 1.5 : 0 },
                    React.createElement(StackView, { axis: "horizontal" },
                        React.createElement(Menu.Item, null,
                            React.createElement(Text, { weight: 600 }, groupDisplayName)),
                        isSelectAll[groupName] && (React.createElement(StackView, { padding: 1, marginLeft: "auto" },
                            React.createElement(Button, { disabled: tooManyOptionsForSelectAll, fontWeight: 400, onClick: (e) => {
                                    onChange({
                                        appName: "Services",
                                        values: (prev) => ({
                                            ...prev,
                                            teams: [
                                                ...prev.teams,
                                                ...groupOptions.map((option) => option.value),
                                            ],
                                        }),
                                    });
                                    ref.current && ref.current.handleBlur(e);
                                }, size: "xs", theme: "primary", title: "Select all", tooltip: {
                                    popoverProps: { zIndex: 10000 },
                                    title: tooManyOptionsForSelectAll
                                        ? `Disabled when options would exceed ${SELECT_ALL_LIMIT}`
                                        : `select all in "${groupDisplayName}"`,
                                }, variant: "naked" })))),
                    items)) : (items);
            })) : (React.createElement(Menu.Item, null,
                React.createElement(Text, null,
                    "No matching teams for:",
                    " ",
                    React.createElement(Text, { as: "span", inline: true, italic: true }, `"${searchTerm}"`))))))));
};

export { Teams };
//# sourceMappingURL=teams.js.map
